import actions from './actions';

const initState = {
  otherApps: null,
  roles: null,
  schools: null,
  grades: null,
  users: null,
  key: null,
};

export default function otherAppVersionReducer(state = initState, action) {
  switch (action.type) {
    case actions.FETCH_OTHER_APPS_SUCCESS:
      return { ...state, otherApps: action.otherApps };
    case actions.FETCH_OTHER_APP_USERS_SUCCESS:
      return { ...state, users: action.users };
    case actions.FETCH_OTHER_APP_CONFIGS_SUCCESS:
      return {
        ...state,
        roles: action.roles,
        schools: action.schools,
        grades: action.grades,
      };
    case actions.SET_FILTER:
      return { ...state, key: action.key };
    case actions.RESET:
      return { ...state, otherApps: null };
    default:
      return state;
  }
}
